import Turbine from './Turbine';

export default Turbine;
